import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=0f933138&scoped=true"
import script from "./curriculum.vue?vue&type=script&lang=js"
export * from "./curriculum.vue?vue&type=script&lang=js"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=0f933138&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f933138",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f933138')) {
      api.createRecord('0f933138', component.options)
    } else {
      api.reload('0f933138', component.options)
    }
    module.hot.accept("./curriculum.vue?vue&type=template&id=0f933138&scoped=true", function () {
      api.rerender('0f933138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/personalDetail/curriculum.vue"
export default component.exports